import React from 'react';
import { Grid, Typography } from '@mui/material';
import { useCookies } from 'react-cookie';
import { SparkButton, SparkDialog } from 'sharedComponents/UI';
import { useDialog } from 'hooks/common';
import type { ActionPrompt } from 'types/common/ErrorResponse';
import { useNavigate } from 'react-router-dom';
import { SparkImageLoader } from 'sharedComponents/UI';

type ErrorModalProviderProps = {
  children: React.ReactNode;
};
const ErrorModalProvider = ({ children }: ErrorModalProviderProps) => {
  const cookieOption = useCookies();
  const cookies = cookieOption[0];
  const removeCookies = cookieOption[2];
  const navigate = useNavigate();

  const { open, closeDialog, openDialog } = useDialog();

  const errorActionPrompt = cookies.errorActionPrompt as
    | ActionPrompt
    | undefined;

  const handleClose = React.useCallback(() => {
    removeCookies('errorActionPrompt', { path: '/' });
    closeDialog();
  }, [closeDialog, removeCookies]);

  const handleNavigate = () => {
    handleClose();
    if (!!errorActionPrompt?.ctaRoute) {
      navigate(errorActionPrompt.ctaRoute);
      return;
    }
    window.open(errorActionPrompt?.ctaLink);
  };

  React.useEffect(() => {
    if (errorActionPrompt) {
      openDialog();
    }
    // remove error state on load
    window.addEventListener('load', handleClose);
    return () => window.removeEventListener('load', handleClose);
  }, [closeDialog, errorActionPrompt, handleClose, openDialog]);
  return (
    <>
      {children}
      {!!errorActionPrompt && (
        <SparkDialog
          open={open}
          onClose={handleClose}
          title={errorActionPrompt.title}
        >
          <Grid
            container
            justifyContent='center'
            alignItems='center'
            direction='column'
            gap={2}
          >
            <SparkImageLoader
              width={80}
              height={80}
              src={errorActionPrompt?.iconURL}
              alt='Icon'
            />
            <Grid item xs={12}>
              <Typography variant='subtitle1'>
                {errorActionPrompt.description}
              </Typography>
            </Grid>

            <Grid item>
              <SparkButton
                variant='contained'
                onClick={handleNavigate}
                fullWidth={false}
                sx={{ alignSelf: 'flex-end' }}
              >
                {errorActionPrompt.ctaLabel}
              </SparkButton>
            </Grid>
          </Grid>
        </SparkDialog>
      )}
    </>
  );
};
export default ErrorModalProvider;
